import React, { ReactNode, useEffect } from 'react';
import styles from './styles.module.scss';
import clsx from 'clsx';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  width: string;
  height?: string;
  inputStyles?: string;
  hideScroll?: boolean;
}

const ContextModal: React.FC<ModalProps> = ({ isOpen, onClose, children, width, height, inputStyles, hideScroll }) => {
  useEffect(() => {
    if (!isOpen || !hideScroll) return;
    document.body.classList.add('hideScroolling');
    document.getElementById('header')?.classList.add('pr-1.5');
    return () => {
      document.body.classList.remove('hideScroolling');
      document.getElementById('header')?.classList.remove('pr-1.5');
    };
  }, [isOpen, hideScroll]);

  return (
    <>
      {isOpen && (
        <>
          <button className={styles.modalOverlay} onClick={onClose} />
          <div
            className={clsx(styles.modalContent, inputStyles)}
            style={{ '--dynamic-width': width, '--dynamic-height': height } as React.CSSProperties}
          >
            {children}
          </div>
        </>
      )}
    </>
  );
};

export default ContextModal;
